// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"9751ca1f","584":"c44f61a1","626":"5e9201e4"}[chunkId] + ".chunk.css";
};